const styles = theme => ({
  // rightSide: {
  //     backgroundColor: '#fff',
  //     padding: '10px',
  //     // border: '1px solid #ddd',
  //     borderRadius: '4px',
  //     // minWidth: '300px', // Ensure the quote section is at least 300px wide
  //     // maxWidth: '300px', // Prevent it from expanding
  //     // flexShrink: 0, // Prevent shrinking
  //   },
  tableContainer: {
    border: '1px solid #ddd',
    padding: '10px',
    borderRadius: '4px',
  },
  input: {
    width: '60px',
    border: '1px solid #bfbfbf',
    fontColor: '#414141',
  },
  totals: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '5px',
    margin: '20px 0',
    padding: '10px',
    backgroundColor: '#F9F9F9',
    width: '50%',
    marginLeft: 'auto',
  },
  totalSection: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '5px',
    alignItems: 'center',
    '& span:first-of-type': {
      fontWeight: 'bold',
    },
  },
  discountInputWrapper: {
    position: 'relative',
    '& span': {
      position: 'absolute',
      top: '2px',
      right: '2px',
      color: '#414141',
    },
    '& input': {
      paddingRight: '15px',
      textAlign: 'right',
      border: '1px solid #bfbfbf',
      fontColor: '#414141',
    },
  },
  selectedOffers: {
    '& h3': {
      fontSize: '18px',
      marginTop: '10px',
    },
  },
  selectedOffersTableWrapper: {
    width: '100%',
    overflowX: 'auto',
    // border: '1px solid #ddd',
    padding: '5px',
  },
  selectedOffersTable: {
    width: '100%',
    // overflowX: 'auto',
    // tableLayout: 'fixed'
  },
  disclaimer: {
    fontSize: '12.5px',
    color: '#888888',
    fontStyle: 'italic',
    padding: '10px 0',
    maxWidth: '500px',
  },
  th: {
    textAlign: 'left',
    position: 'sticky',
    top: 0,
    background: '#F9F9F9',
    zIndex: 10,
    padding: '10px 5px 20px 5px',
  },
  'tr:nth-child(odd)': {
    backgroundColor: '#f6f6f6',
  },
  td: {
    paddingRight: '5px',
    color: '#414141',
    paddingLeft: '5px',
    fontSize: '13px',
    // minWidth: '100px',
    paddingTop: '4px',
    paddingBottom: '4px',
    '& input': {
      width: '30px',
    },
  },
  removeBtn: {
    background: '#FFFFFF',
    border: 'none',
    color: 'red',
    fontWeight: 'bold',
    fontSize: '11px',
    cursor: 'pointer',
  },
  btnFilled: {
    ...theme.btnFilled,
    marginTop: '10px',
    marginLeft: 'auto',
  },
  totalSectionMultiLine: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '4px',
  },
  spanSmall: {
    color: '#838383',
    fontSize: '11px',
    fontStyle: 'italic',
  },
  span: {
    color: '#414141',
  },
});

export default styles;
